"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeBindOperation = void 0;
var common_evm_utils_1 = require("@moralisweb3/common-evm-utils");
exports.removeBindOperation = {
    method: 'POST',
    name: 'removeBind',
    id: 'removeBind',
    groupName: 'evm',
    urlPathPattern: '/bind/remove',
    bodyParamNames: ['blockchainType', 'address', 'profileId', 'publicKey'],
    bodyType: 'properties',
    getRequestUrlParams: getRequestUrlParams,
    getRequestBody: getRequestBody,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
    deserializeResponse: deserializeResponse,
};
// Methods
function getRequestUrlParams() {
    return {};
}
function getRequestBody(request, core) {
    return {
        blockchainType: request.blockchainType,
        address: common_evm_utils_1.EvmAddress.create(request.address, core).checksum,
        profileId: request.profileId,
        publicKey: request.publicKey,
    };
}
function deserializeResponse(jsonResponse) {
    return jsonResponse;
}
function serializeRequest(request, core) {
    return {
        blockchainType: request.blockchainType,
        address: common_evm_utils_1.EvmAddress.create(request.address, core).checksum,
        profileId: request.profileId,
        publicKey: request.publicKey,
    };
}
function deserializeRequest(jsonRequest, core) {
    return {
        blockchainType: jsonRequest.blockchainType,
        address: common_evm_utils_1.EvmAddress.create(jsonRequest.address, core),
        profileId: jsonRequest.profileId,
        publicKey: jsonRequest.publicKey,
    };
}
//# sourceMappingURL=removeBindOperation.js.map